import { Box, IconButton, Typography } from '@mui/material'
import ArrowRightIcon from "@mui/icons-material/ArrowRight"
import ArrowDownIcon from "@mui/icons-material/ArrowDropDown"

type Props = {}

const GoalsMetricNameCell = (props: any) => {

    const { row, renderedCellValue } = props

    return (
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-start" }} >
            {row.getCanExpand() ? (<IconButton
                sx={{ marginLeft: row.depth == 1 ? "20px" : "0px" }}
                id="basic-button"
                aria-haspopup="true"
                onClick={row.getToggleExpandedHandler()}
            >
                {row.getIsExpanded() ? <ArrowDownIcon /> : <ArrowRightIcon />}
            </IconButton>) : (null)}
            <Typography sx={{ marginLeft: row.depth == 2 ? "40px" : "0px" }} fontWeight={row.depth == 1 ? "700" : row.depth == 0 ? "600" : "500"} color={row.depth == 0 ? "#3C77EF" : "#000000"} >{renderedCellValue}</Typography>
        </Box>
    )
}

export default GoalsMetricNameCell